// The routes this module owns, as the app mounts them. `route.ts` takes its mount from here and
// `src/app/paths.ts` merges this into the one `paths` object, so a link and a route cannot drift.
type Id = string | number | undefined;

export const livePaths = {
  base: '/services/live',
  /** One service of this module (its console root). */
  service: (serviceId: Id) => `/services/live/${serviceId}`,
} as const;
